import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { AdvtService } from '../../../_services/advt.service';
import { AlertService } from '../../../_services/alert.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { forbiddenNameValidator } from '../../../shared/forbidden-name.directive';
import { Router, ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NotificationsService } from 'angular2-notifications';
import { Location } from '@angular/common';
import { UserService } from '../../../_services/index';
import { Country, States, Cities } from '../../../_models/index';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  @ViewChild('imageUploader') public imageUploader: ElementRef;
  @ViewChild('alertVulgarTemplate') alertVulgarTemplate: TemplateRef<any>;

  currentUser;
  user_id;
  public thisUser;
  public changePasswordData;
  countries: Country[] = [];
  states: States[] = [];
  cities: Cities[] = [];
  mystate: number;
  mycity: number;
  loading = false;
  imageChange = undefined;
  logoimage: any;
  isstateloaded = false;
  iscityloaded = false;
  modalRef: BsModalRef;
  heroForm: FormGroup;
  isUsernameAvailable = false;
  accessToken: string;
  imgs: any = [];

  constructor(private advtService: AdvtService,
    private alertService: AlertService,
    private userService: UserService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private _service: NotificationsService,
    private router: Router,
    private _location: Location) {

    this.thisUser = {
      userId: '',
      firstName: '',
      lastName: '',
      username: '',
      emailId: '',
      country_id: '',
      state_id: '',
      city_id: '',
      address: '',
      zipCode: '',
      image: '',
      lat: '',
      lng: ''
    };


  }


  ngOnInit() {
    const userInfos = JSON.parse(localStorage.getItem("currentUser"));
    this.accessToken = userInfos.access_token;

    this.heroForm = new FormGroup({
      'firstname': new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        forbiddenNameValidator(/bob/i) // <-- Here's how you pass in the custom validator.
      ]),
      'lastname': new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        forbiddenNameValidator(/tob/i) // <-- Here's how you pass in the custom validator.
      ]),
      'username': new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        forbiddenNameValidator(/tob/i) // <-- Here's how you pass in the custom validator.
      ]),
      'address': new FormControl('', Validators.required),
      'country': new FormControl('', Validators.required),
      'state': new FormControl('', Validators.required),
      'city': new FormControl('', Validators.required),
    });

    const userInfo = JSON.parse(localStorage.getItem('currentUser'));
    //  this.currentUser = userInfo ? userInfo.result : null;

    // Fetch user data.
    this.advtService.getUserInfo()
      .subscribe((response) => {
        this.thisUser = {
          userId: response.result.id,
          firstName: response.result.first_name,
          lastName: response.result.last_name,
          username: response.result.username,
          emailId: response.result.email,
          country_id: response.result.country_id,
          state_id: response.result.state_id,
          city_id: response.result.city_id,
          address: response.result.address,
          zipCode: response.result.zip_code,
          image: response.result.image,
          lat: response.result.lat,
          lng: response.result.lng
        };

        this.onChangeCountry(this.thisUser.country_id, true);
        this.onChangeState(this.thisUser.state_id, true);
      });


    this.logoimage = '../../assets/images/logomain.png';
    this.userService.getAllCountry().subscribe(
      data => {
        this.countries = data;
        this.loading = false;
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      });


  }

  backClicked() {
    this._location.back();
  }

  public onChangeCountry(country_id, onload = false): void {  // event will give you full breif of action
    this.thisUser.country = country_id;
    this.isstateloaded = true;
    this.userService.getAllStates(country_id).subscribe(
      data => {
        this.states = data;
        this.isstateloaded = false;
        if (!onload)
          this.onChangeState(data[0].id, false);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      });
  }

  public onChangeState(state_id, onLoad = false): void {  // event will give you full breif of action
    // alert(state_id);
    this.thisUser.state_id = state_id;
    if (!onLoad)
      this.thisUser.city_id = 0;
    this.iscityloaded = true;

    this.userService.getAllCities(state_id).subscribe(
      data => {
        if (!onLoad && data.length > 0) {
          this.thisUser.city_id = data[0].id;
        }

        this.cities = data;
        this.iscityloaded = false;
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      });
  }

  public saveProfile() {
    const data = {
      user_id: this.thisUser.userId,
      first_name: this.thisUser.firstName,
      last_name: this.thisUser.lastName,
      address: this.thisUser.address,
      country_id: this.thisUser.country,
      state_id: this.thisUser.state_id,
      city_id: this.thisUser.city_id,
      zip_code: this.thisUser.zipCode,
      lat: this.thisUser.lat,
      lng: this.thisUser.lng,
      image: null,
    };
    const userInfo = JSON.parse(localStorage.getItem('currentUser'));
    userInfo.result.first_name = data.first_name;
    localStorage.setItem("currentUser", JSON.stringify(userInfo));  //put the object back
    if (this.imageChange !== undefined) {
      this.userService.imageUpload(this.imageChange)
        .subscribe(
          (image: any) => {
            data.image = image.media_original_url;
            this.uploadProfile(data);
          }, error => {
          });
    } else {
      delete data.image;
      this.uploadProfile(data);
    }


  }

  uploadProfile(data) {
    this.userService.updateUserAccount(data).subscribe(
      data => {
        setTimeout(() => {
          this.router.navigate(['/dashboard']);
        }, 1000);
      },
      error => {
        this.alertService.error(error);
      }
    );
  }

  profileImageChange(fileInput: any) {
    for (let i = 0; i < fileInput.target.files.length; i++) {
      const singleFile = fileInput.target.files[i];
      this.advtService.AIimageScan(singleFile)
        .subscribe(
          (response: any) => {
            if (response.data.issafe === 0) {
              const reader = new FileReader();
              reader.onload = (e: any) => {
                this.thisUser.image = e.target.result;
                this.imageChange = fileInput;
              };
              reader.readAsDataURL(fileInput.target.files[0]);
            } else if (response.data.issafe === 1) {
              this.openAlertModal();
            }
          },
        );
    }
  }
  public updatePassword() {
    const data = {
      current_password: this.changePasswordData.currentPassword,
      new_password: this.changePasswordData.newPassword,
      new_password_confirm: this.changePasswordData.confirmPassword
    };

    this.userService.updatePassword(data).subscribe(
      data => {
        if (data.status === 200) {
          this.alertService.success(data.message);
        } else {
          this.alertService.error(data.message);
          window.scrollTo(0, 0);
        }
        this.modalRef.hide();
      },
      error => {
        this.alertService.error(error);
        this.modalRef.hide();
      }
    );
  }

  onKeyCheckUsername(event: any) { // without type info
    const username = event.target.value;
    if (username !== '') {
      this.userService.getUserByUsername(username).subscribe(
        data => {
          if (data.status === 200) {
            this.isUsernameAvailable = false;
          }

          if (data.status === 400) {
            this.isUsernameAvailable = true;
          }

        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
    }

  }

  /**
   * Function to open modal
   * @param template
   */
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-md' })
    );
  }

  /**
   * function to Disbale Modal
   * @param event
   */
  _hidemodal(event: any) {
    this.modalRef.hide();
  }

  openAlertModal() {
    this.modalRef = this.modalService.show(this.alertVulgarTemplate);
  }
  CancelButton() {
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/authorized-data/user/user-profile/user-profile.component.ts